import { Operator, StatisticsRatingProps } from './StatisticsRating.props';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from 'recharts';
import { generateColor } from '../../utils/utils';
import './StatisticsRating.scss';


function StatisticsRating({ ALL, BAD_ANSWERS, AVERAGE_ANSWERS, GOOD_ANSWERS }: StatisticsRatingProps ) {        // страница СТАТИСТИКА (статистика ОЦЕНОК обращений)

  const renderList = (list: Operator[]) => {
    return list.map((item) => {
      return (
        <li className="statistics__list-item" key={item.OPERATOR_ID}>
          {item.NAME}: <span className="statistics__result">{item.COUNT}</span>
        </li>
      );
    });
  };

  const data_bad = BAD_ANSWERS.map((item, index) => ({
    name: item.NAME,
    value: Number(item.COUNT),
  }));

  const data_average = AVERAGE_ANSWERS.map((item, index) => ({
    name: item.NAME,
    value: Number(item.COUNT),
  }));

  const data_good = GOOD_ANSWERS.map((item, index) => ({
    name: item.NAME,
    value: Number(item.COUNT),
  }));


  const badAnswersList = renderList(BAD_ANSWERS);
  const averageAnswersList = renderList(AVERAGE_ANSWERS);
  const goodAnswersList = renderList(GOOD_ANSWERS);

  const colorsBad = generateColor(data_bad.length);
  const colorsAverage = generateColor(data_average.length);
  const colorsGood = generateColor(data_good.length);


  return (
    <div className="statistics__page-container">
      <div className="statistics__wrapper">
        <div className="statistics__all">
          Всего оценок: <span className="statistics__result">{ALL.ALL_RATE}</span>
        </div>

        <div className="statistics__completed">
          Удовлетворён ответом: <span className="statistics__result">{ALL.GOOD}</span>
          <ul className="statistics__list">{goodAnswersList}</ul>
        </div>
      
        <div className="statistics__completed">
          Частично удовлетворён ответом: <span className="statistics__result">{ALL.AVERAGE}</span>
          <ul className="statistics__list">{averageAnswersList}</ul>
        </div>

        <div className="statistics__completed">
          Не удовлетворён ответом: <span className="statistics__result">{ALL.BAD}</span>
          <ul className="statistics__list">{badAnswersList}</ul>
        </div>
      </div>

      <div>
        <div>
          <div className="statistics__completed statistics__completed_chart">
            Удовлетворительный ответ:
          </div>
          <BarChart width={600} height={300} data={data_good}>
            <XAxis dataKey="name" angle={-85} textAnchor="end" interval={0} height={100} tick={{fontSize: 13}} />
            <Tooltip />
            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
            <Bar dataKey="value" fill="#8884d8">
              {data_good.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colorsGood[index]} />
              ))}
            </Bar>
          </BarChart>
        </div>

        <div>
          <div className="statistics__completed statistics__completed_chart">
            Частично удовлетворительный ответ:
          </div>
          <BarChart width={600} height={300} data={data_average}>
            <XAxis dataKey="name" angle={-85} textAnchor="end" interval={0} height={100} tick={{fontSize: 13}} />
            <Tooltip />
            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
            <Bar dataKey="value" fill="#8884d8">
              {data_average.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colorsAverage[index]} />
              ))}
            </Bar>
          </BarChart>
        </div>

        <div>
          <div className="statistics__completed statistics__completed_chart">
            Неудовлетворительный ответ:
          </div>
          <BarChart width={600} height={300} data={data_bad}>
            <XAxis dataKey="name" angle={-85} textAnchor="end" interval={0} height={100} tick={{fontSize: 13}} />
            <Tooltip />
            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
            <Bar dataKey="value" fill="#8884d8">
              {data_bad.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colorsBad[index]} />
              ))}
            </Bar>
          </BarChart>
        </div>
      </div>
    </div>
  );
}

export default StatisticsRating;